<template>
  <main class="px-5 md:px-20 2xl:px-15 text-sm relative transition-[padding]">
    <a
      :href="`#${t('content')}`"
      class="fixed top-0 left-0 w-full p-2 text-center transition-transform bg-[#2D2E85] text-white -translate-y-full focus:translate-y-0 focus:underline z-50"
      >{{ t('skip_to_content') }}</a
    >
    <div
      class="lg:bg-white pt-7.5 md:pt-20 lg:pb-15 2xl:pt-15 transition-[padding]"
    >
      <img
        :src="logo"
        :alt="t('alt.logo')"
        class="w-42.5 lg:w-55 2xl:w-75 mx-auto 2xl:absolute transition-[width]"
      />
      <div
        class="grid grid-cols-2 mt-10 lg:mt-12.5 2xl:mt-0 gap-5 lg:gap-6 2xl:w-116 2xl:absolute right-15 transition-[gap_margin]"
      >
        <LegendList
          type="personas"
          @update:tooltip="updateToolTip"
          @remove:tooltip="remove"
          :tooltip="tooltip"
        />
        <LegendList
          type="principles"
          @update:tooltip="updateToolTip"
          @remove:tooltip="remove"
          :tooltip="tooltip"
        />
      </div>
    </div>
    <h1
      class="mt-10 lg:mt-0 lg:mx-auto w-full lg:w-157.5 2xl:w-85 2xl:aspect-square max-w-87.5 lg:max-w-none bg-light-grey lg:flex lg:justify-center lg:items-center lg:text-center py-4 px-5 lg:p-10 rounded-lg 2xl:rounded-full font-bold text-xl lg:text-4xl transition-[width_padding_border-radius]"
    >
      {{ t('title') }}
    </h1>
    <span
      class="w-8.5 lg:w-full lg:absolute lg:-z-10 lg:top-15 lg:left-0 flex justify-center lg:h-[calc(100%-120px)] transition-[width_height]"
    >
      <span
        class="w-1.5 lg:w-2.5 h-8.5 lg:h-full bg-light-grey transition-[width_height]"
      ></span>
    </span>
    <div :id="t('content')" class="lg:mt-22.5">
      <PhaseCard
        v-for="(phase, index) in content.phases"
        :phase="phase"
        :index="index + 1"
        :key="phase.key"
        :tooltip="tooltip"
        @update:tooltip="updateToolTip"
        @remove:tooltip="remove"
      />
    </div>
    <ToolTip :tooltip="tooltip" @close="close" />
  </main>
  <SiteFooter />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import logo from '@/assets/logo.png'
import { useToolTip } from '@/composables/useToolTip.ts'
import content from '@/content.ts'
import PhaseCard from '@/components/cards/PhaseCard.vue'
import LegendList from '@/components/blocks/LegendList.vue'
import ToolTip from '@/components/blocks/ToolTip.vue'
import SiteFooter from '@/components/sections/SiteFooter.vue'

const { t } = useI18n()

const { tooltip, close, remove, updateToolTip } = useToolTip()
</script>
